<!-- FOOTER — Dark Premium -->
<footer class="footer">
  <!-- Ligne de séparation lumineuse -->
  <div class="footer-glow-line"></div>

  <div class="container">
    <!-- Top -->
    <div class="footer-top">
      <!-- Brand -->
      <div class="footer-brand">
        <a routerLink="/" class="footer-logo">
          <img src="assets/images/logo-dmed.jpg" alt="D-Med Express" class="footer-logo-img" onerror="this.style.display='none'">
          <span class="footer-logo-text">D-Med <span>Express</span></span>
        </a>
        <p class="footer-desc">
          Votre pharmacie, partout à Abidjan. Médicaments, ordonnances et conseils santé,
          en partenariat avec des pharmacies agréées par le Ministère de la Santé de Côte d'Ivoire.
        </p>

        <!-- Paiements -->
        <div class="footer-payments">
          <span class="fp-label">Paiements :</span>
          <div class="fp-chips">
            <span class="fp-chip">📱 Wave</span>
            <span class="fp-chip">🟠 Orange Money</span>
            <span class="fp-chip">🟡 MTN Money</span>
            <span class="fp-chip">💵 Espèces</span>
          </div>
        </div>
      </div>

      <!-- Liens -->
      <div class="footer-links-grid">
        <div class="footer-col">
          <h4>Services</h4>
          <a routerLink="/prescription/upload">Envoyer une ordonnance</a>
          <a routerLink="/catalog">Catalogue médicaments</a>
          <a routerLink="/orders/track">Suivre ma livraison</a>
          <a routerLink="/chat">Conseils santé IA</a>
          <a routerLink="/cart">Mon panier</a>
        </div>
        <div class="footer-col">
          <h4>Mon Compte</h4>
          <a routerLink="/login">Se connecter</a>
          <a routerLink="/register">Créer un compte</a>
          <a routerLink="/profile">Mon profil</a>
          <a routerLink="/patient/dashboard">Tableau de bord</a>
        </div>
        <div class="footer-col">
          <h4>Informations</h4>
          <a href="#">Qui sommes-nous ?</a>
          <a href="#">Pharmacies partenaires</a>
          <a href="#">Conditions générales</a>
          <a href="#">Politique de confidentialité</a>
          <a href="#">Données de santé (RGPD)</a>
        </div>
      </div>
    </div>

    <div class="footer-divider"></div>

    <!-- Bottom -->
    <div class="footer-bottom">
      <div class="footer-bottom-left">
        <p>© 2026 D-Med Express · Abidjan, Côte d'Ivoire</p>
        <div class="footer-trust-badges">
          <span class="ftb">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            Certifié
          </span>
          <span class="ftb">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>
            Pharmacies agréées
          </span>
        </div>
      </div>
      <div class="footer-socials">
        <a href="#" aria-label="Twitter" class="social-btn">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
        </a>
        <a href="#" aria-label="Instagram" class="social-btn">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="5"/><circle cx="17.5" cy="6.5" r="1.5" fill="currentColor" stroke="none"/></svg>
        </a>
        <a href="#" aria-label="WhatsApp" class="social-btn">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>
        </a>
      </div>
    </div>
  </div>
</footer>
